import { useId } from "react";


export function Input(props: React.ComponentProps<"input"> & { readonly label?: string; }) {
	const id = useId();

	return <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
		{props.label != null && (
			<label className="labelsForm" htmlFor={id}>{props.label}</label>
		)}
		<input
			className="inputsForm"
			id={id}
			{...props}
		/>
	</div>;
}